import { extend } from 'vee-validate';
import { required, email, regex, min, max, numeric, min_value, max_value } from 'vee-validate/dist/rules';


import { messages as messageEn } from 'vee-validate/dist/locale/en.json';
import { messages as messageNl } from 'vee-validate/dist/locale/nl.json';
import { messages as messageJA } from 'vee-validate/dist/locale/ja.json';

import { messages as customVeeMessageEn } from '@/locale/vee-validate/en.json';
import { messages as customVeeMessageNl } from '@/locale/vee-validate/nl.json';
import Vue from 'vue';

const veeLocale = window.afConfig?.locale || 'en';

let veeMessages = messageEn;
let veeCustomMessages = customVeeMessageEn;

if (veeLocale === 'nl') {
    veeMessages = messageNl;
    veeCustomMessages = customVeeMessageNl;
}

if (veeLocale === 'ja') {
    veeMessages = messageJA;
}

import moment from 'moment/src/moment';

extend('object', {
    validate(value, args) {
        if (typeof value !== 'object' || !value[args.key]) {
            return false;
        }

        return value[args.key] !== '';
    },
    params: ['key'],
    message: veeCustomMessages.this_is_required,
});

extend('required', {
    ...required,
    message: veeMessages.required,
});

extend('numeric', {
    ...numeric,
    message: messageEn.numeric,
});

extend('email', {
    ...email,
    message: veeMessages.email,
});

extend('regex', {
    ...regex,
    message: veeMessages.regex,
});

extend('passwordc', {
    params: ['target'],
    validate: (value, { target }) => {
        return value === target;
    },
    message: veeCustomMessages.password_confirmation,
});

extend('min', {
    ...min,
    message: veeMessages.min,
});

extend('max', {
    ...max,
    message: veeMessages.max,
});

extend('min_value', {
    ...min_value,
    message: veeMessages.min_value,
});

extend('max_value', {
    ...max_value,
    message: veeMessages.max_value,
});


extend('password', {
    params: ['target'],
    validate: (value, { target }) => {
        return value === target;
    },
    message: veeCustomMessages.password,
});

extend('verify_password', {
    params: ['target'],
    validate: (value) => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-_])(?=.{8,})');
        return strongRegex.test(value);
    },
    message: veeCustomMessages.verify_password,
});

extend('phone_number', {
    params: ['target'],
    validate: (value) => {
        const regular_expression = window?.afConfig?.phone_format || /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$/;
        return value.match(regular_expression);
    },
    message: veeCustomMessages.phone_number,
});

extend('date_of_birth', {
    params: ['target'],
    validate: (value) => {
        const dat = moment(value, 'YYYY-MM-DD');
        if (dat > moment(new Date()).subtract(10, 'years') || dat < moment(new Date()).subtract(90, 'years') || !dat.isValid()) {
            return false;
        }
        return true;
    },
    message: veeCustomMessages.date_of_birth,
});

extend('url', {
    params: ['target'],
    validate: (value) => {
        var strongRegex = new RegExp('(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=-@]*)?(\\#[-a-z\\d_@]*)?$', 'i');
        return strongRegex.test(value);
    },
    message: veeCustomMessages.url,
});

extend('lessthan', {
    params: ['max'],
    validate(value, { max }) {
        if (max) {
            return parseInt(value) < parseInt(max);
        } else {
            return true;
        }
    },
    message: veeCustomMessages.lessthan,
});

extend('greaterthan', {
    params: ['min'],
    validate(value, { min }) {
        if (min) {
            return parseInt(value) > parseInt(min);
        } else {
            return true;
        }
    },
    message: veeCustomMessages.greaterthan,
});

extend('lte', {
    params: ['max'],
    validate(value, { max }) {
        if (max) {
            return parseInt(value) <= parseInt(max);
        } else {
            return true;
        }
    },
    message: veeCustomMessages.lessthan,
});

extend('gte', {
    params: ['min'],
    validate(value, { min }) {
        if (min) {
            return parseInt(value) >= parseInt(min);
        } else {
            return true;
        }
    },
    message: veeCustomMessages.greaterthan,
});

extend('email_exists', {
    params: [],
    async validate(value) {
        if (value) {
            const url = `v1/users/check-email?email=${encodeURIComponent(value)}`;
            try {
                await Vue.$axios.$get(url);
            } catch (_) {
                return true;
            }

            return false;
        } else {
            return true;
        }
    },
    message: 'email_taken',
});

